import * as React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import L2DApiProvider from '@europrocurement/l2d-domain/providers/L2DApiProvider/L2DApiProvider';
import App from './App';

import ErrorBoundary from './ErrorBoundary';

import ReduxProvider from './ReduxProvider';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

const apiConfiguration = {};

root.render(
    <ErrorBoundary>
        <L2DApiProvider apiConfiguration={apiConfiguration}>
            <React.StrictMode>
                <BrowserRouter>
                    <ReduxProvider>
                        <App />
                    </ReduxProvider>
                </BrowserRouter>
            </React.StrictMode>
        </L2DApiProvider>
    </ErrorBoundary>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
